import { apiClient } from '@isocel/front-common';

import { BaseModel, Package, PackagingConfig } from './types';

export const fetchPackageTypes = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageTypes`);
    return data;
};

export const fetchPackageCategories = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageCategories`);
    return data;
};

export const fetchModels = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageModels`);
    return data;
};

export const fetchPackages = async (): Promise<Package[]> => {
    const { data } = await apiClient().get(`/packages`);
    return data;
};

export const fetchPackagingConfig = async (): Promise<PackagingConfig> => {
    const { data } = await apiClient().get(`/packagingConfig`);
    // No need to merge with base64 images anymore - packagetype icons come from GCP via iconRemoteFile
    return data;
};

export const updatePackage = async (
    id: string,
    payload: {
        orgInternCodes?: Array<{
            _id?: string;
            organization?: string;
            code: string;
            ean?: number[];
            unitPriceToInvoice?: number;
            tvaCodeToInvoice?: string;
        }>;
    }
): Promise<Package> => {
    const { data } = await apiClient().put(`/packages/${id}`, payload);
    return data;
};
